/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CmisRenditionType { 
    streamId: string;
    mimetype: string;
    length: number;
    kind: string;
    title?: string;
    height?: number;
    width?: number;
    renditionDocumentId?: string;
    any?: Array<object>;
}

